export default "__VITE_ASSET__d5131c4c__"